
const progress = document.querySelector(".progress-done");

let lastKnownProgress = parseInt(progress.getAttribute("data-done"), 10) || 0;

function updateFreeShippingProgress() {
  fetch("/cart.js")
    .then((res) => res.json())
    .then((cart) => {
      const progressEl = document.getElementById("free-shipping-progress");
      if (!progressEl) return;

      const threshold = parseInt(progressEl.dataset.threshold, 10);
      const cartTotal = cart.total_price;
      const newProgress = Math.min((cartTotal / threshold) * 100, 100).toFixed(
        0
      );

      const progressBar = progressEl.querySelector(".progress-done");
      if (progressBar) {
        const progressDifference = newProgress - lastKnownProgress;

        progressBar.style.width = `${newProgress}%`;
        progressBar.style.opacity = "1";
        progressBar.setAttribute("data-done", newProgress);

        lastKnownProgress = newProgress;
      }
    });
}

function debounce(fn, delay) {
  let timer;
  return function () {
    clearTimeout(timer);
    timer = setTimeout(() => fn.apply(this, arguments), delay);
  };
}

const debouncedUpdate = debounce(updateFreeShippingProgress, 200);

function observeCartChanges() {
  const cartContainer =
    document.querySelector("#CartContainer") || document.body;

  const observer = new MutationObserver(() => {
    debouncedUpdate();
  });

  observer.observe(cartContainer, {
    childList: true,
    subtree: true,
  });
}

document.addEventListener("DOMContentLoaded", () => {
  updateFreeShippingProgress();
  observeCartChanges();
});

document.addEventListener("DOMContentLoaded", function () {
  const storedUrl = localStorage.getItem('lastShoppingPage');
  const continueLink = document.getElementById('continue-shopping-link');

  if (storedUrl && (storedUrl.includes('/collections') || storedUrl.includes('/products'))) {
    continueLink.setAttribute('href', storedUrl);
  } else {
    continueLink.setAttribute('href', '/collections/');
  }
});